<template>
    <div>
                <header class="header">
                <img src="../../../static/img/banner1.png" alt="">
                <div class="nav">
                    <div class="nav_left">
                        <img src="../../../static/img/logo_.png" alt="">
                    </div>
                    <div class="nav_right">
                <ul>
                    <li @click="index()" class="pointer_box">
                        首页
                    </li>
                    <li @click="dowapp()"  class="pointer_box">
                        大救星APP
                    </li>
                    <li @click="contact()" class="pointer_box">
                        合作咨询
                    </li>
                    <li class="pointer_box">
                        <p class="btn_l" @click="listlogin()">登录</p>
                    <ol class="login">
                        <span></span>
                        <li class="login_btn btn" @click="login(0)">救援机构入口</li>
                        <li class="login_btn btn" @click="login(2)">监管机构入口</li>
                        <li class="login_btn btn" @click="login(1 )">指挥中心入口</li>
                    </ol>
                    </li>
                </ul>
                    </div>
                </div>
            </header>
        <main class="main">
            <nav class="nav">
                <ul>
                <li @click="aboutus()" class="pointer_box">关于我们</li>
                <li @click="news()" class="pick pointer_box">新闻中心</li>
                <li @click="league()" class="pointer_box">全球救援联盟</li>
                <li @click="stars()" class="pointer_box">星使服务</li>
                </ul>
            </nav>
            <section class="section">
 <div class="newsDetail" >
<h5>玄武湖畔各界嘉宾云集 钟山脚下共话全球救援</h5>
<h6>----2017全球救援服务论坛在南京成功召开</h6>
<p style="text-indent:2em;">2017年3月22日，由江泰国际合作联盟和江泰全球救援联盟共同主办的“2017全球救援服务论坛”在南京召开。</p>
<p  style="text-indent:2em;">有超过1500名来自境内外的旅游行业及相关行业的嘉宾出席了会议。</p>
<p  style="text-indent:2em;">本次论坛邀请到了40余位国内外各界演讲嘉宾，这些演讲嘉宾由行业巨头的高管、高级驻华外交使节及专家、学者组成。</p>
<p  style="text-indent:2em;">本次论坛聚焦国际化背景下“走出去”人群的风险、救援和救助服务及商机等议题。尤其着重探讨出境安全风险包括自然灾害风险、公共卫生风险、社会安全风险和事故灾难风险等应对措施，即如何推动全球化救援服务的发展与实施。</p>
<p  style="text-indent:2em;">详细议题则包括：专业安保服务在不同经济发展程度国家和地区的差异、如何规避境外信用卡盗刷风险、“一带一路”大型承包与投资项目财产与人员的安全保障、海外留学应关注的风险事项、境外频发的恐怖袭击对旅游者的威胁与伤害、海外医疗急救体系剖析等，甚至关注当下时事深入讨论了从中国赴越南游客被越南边检人员殴打事件看海外旅游合法权益维护的重要性等议题。各议题内容新颖、实用、趣味并关注当下热点，受到与会嘉宾的高度关注和积极反馈。</p>
<p  style="text-indent:2em;">众所周知，在过去的30年里，中国经济的快速发展，取得了举世瞩目的成绩，人民生活水平的节节提升，带动了中国人走出去的步伐不断加快。</p>
<p style="text-indent:2em;">根据国家旅游局最新公布的数据，中国出境总人数达到了1.22亿人次，已连续5年居全球出境人数之首。对许多国家来说，中国已经成为他们最大的入境旅游市场，如泰国、韩国、日本、马尔代夫等。众多国家纷纷将中国作为最重要的旅游客源市场进行开发。</p>
<p style="text-indent:2em;">随着中国走出去战略和“一带一路”倡议的稳步推进，出境旅游、商务、劳务、留学和探亲等的人数亦会保持快速增长势头。2016年12月，外交部长王毅就表示，未来5年中国公民出境将达7亿人次。</p>
<p style="text-indent:2em;">然而，在这些快速增长的数字背后，我们也看到，中国公民在境外期间由各种突发疾病和意外事件所受到的伤害案件也成比例增长。传统和非传统领域的安全因素，如战争，自然灾害，恐怖袭击，公共卫生和社会治安等，也都对中国公民在境外构成了潜在和现实的威胁。因此，如何提高中国公民在境外期间的风险意识和防范意识，以及在需要时为他们提供及时的救援和救助服务，将他们受到的伤害和损失减少到最低程度，已经成为政府、社会和企业共同关注的重要问题。</p>
<p style="text-indent:2em;">而随着“走出去”公民人数的快速增加，以领事救助为主的海外救助承载的压力几何增长。从全国旅行社责任统保示范项目的报案数据也能看出其中端倪，2014年全年受理境外报案1466件，而2016年前11个月境外报案已达2433件，与2014年相比翻了一番。</p>
<p style="text-indent:2em;">而目前领事救助受到诸如法律界限、人力、物力等多方限制，无法及时满足和全部满足出境公民的求助需求，难免发生覆盖面不足或是鞭长莫及的情况。此外，出境公民一旦发生重大或紧急情况，其户籍所在地政府也需要赶赴事发地参与救助，手续繁琐，效率也无法保证，也给各级政府带来了压力。</p>
<p style="text-indent:2em;">2014年10月2日，一辆载有中国游客的大巴在南非发生交通事故，造成3死数伤。当地医院在救治过程中产生了数千万元人民币的巨额费用，由于费用支付问题，最后一名伤者在当地医院被拖了近一年才得以回国。期间，大使馆、外交部、旅游局、北京市和组团社进行了多方协调，才使问题获得解决。</p>
<p style="text-indent:2em;">在境外的中国公民中，除出境旅游人群外，还有大量留学生、劳务人员等群体，长期在境外学习、工作，让这些群体面临的风险更加多样与复杂，近年来中国留学生境外遇害的事件也屡屡见诸报端。</p>
<p style="text-indent:2em;">数据显示，中国公民在境外涉及意外重病和意外重伤的出险率约在千分之三左右，约为30万—50万人次。而另有80%的出国人员会在旅游、商务、劳务、留学和探亲活动中产生其它求助需求，如海外医疗、运动防护、航班延误、证件丢失、安保服务、向导服务、法律服务、生活服务等等。但中国出境公民购买旅行意外保险的比例不足50%，现状令人担忧。</p>
<p style="text-indent:2em;">中国旅游研究院院长戴斌认为，随着我国出境游进入“亿人次时代”，加快建立我国出境旅游安全保障体系刻不容缓。要形成个人、企业、非政府组织、政府协同合作的中国公民海外救援体系。</p>
<p style="text-indent:2em;">而在前不久的全国人大代表大会的新闻发布会上，王毅外长表示，领保工作面临的任务越来越繁重，但不管遇到什么样的困难和挑战,我们都一定要把领保工作越做越实,越做越好,让党中央放心,让老百姓安心。</p>

<p style="text-indent:2em;">正是基于上述，江泰以其近十年运行全国旅行社责任险的经验，本着“成全别人，成就自己”的理念，决定为政府分忧，为走出去中国公民担责，开启中国公民海外救援服务事业。诚如江泰全球救援联盟主席、江泰救援服务有限公司董事长沈开涛所说：“中国脚步和中国的海外利益走到哪里，我们的保护与服务就跟到哪里。”</p>
<p style="text-indent:2em;">正是在这个大背景之下，江泰，作为一家具有强烈社会责任感的企业，在公益性的2017中国企业走出去风险发布会上，专门增加了全球救援服务论坛，并邀请到了世界各国相关专业人士和专家学者，对全球旅行风险和救援救助服务等议题进行全面深入的探讨，并深究解决之道。</p>
<p style="text-indent:2em;">正如与会嘉宾意中旅游事务促进会会长史译所言，他已在欧洲从事旅游工作18年，早年公派欧洲调研，后任欧华时报、新华时报、欧洲商旅报总编的他对于华人同胞在异国他乡孤立无援的处境感同身受。他表示，信息的共享让海外救援能够第一时间被触达，解决了传统救援模式单一、被动、耗时、沟通困难、资金无人垫付等一系列落实障碍，为国人出境免除了不少后顾之忧。而自己身为一名华人，不仅为江泰开创的海外救援创新模式倍感欣喜，更是迫不及待参与到星使行列中，成为中国海外救援体系里的一名“小救星”，随时乐意用自己的绵薄之力为到意的祖国同胞提供服务。</p>
<p style="text-indent:2em;">会议主办方，江泰国际合作联盟和江泰全球救援联盟，是分别由江泰保险经纪股份有限公司和江泰救援服务有限公司牵头成立，由世界各国专业服务公司，包括律师事务所、会计师事务所、投资贸易促进机构、救援服务公司、航空医疗转运公司、医疗机构、安保公司、翻译公司、护理公司、旅行社、运动防护机构等组成的全球化服务组织和网络，专门为中国企业走出去和公民走出去提供在全球范围内专业化和本地化的投资贸易和救援救助服务。</p>

<p style="text-indent:2em;">搜狐视频直播网址：<a href="http://bjsite.sohu.com/s2017/jtdjx/">http://bjsite.sohu.com/s2017/jtdjx/</a></p>
<span>2017.3.22</span>
</div>
            </section>
        </main>
        <footer class="footer">
            <div class="con_box">
                <div class="nav_box">
                <p class="pointer_box btn" @click="login(0)">救援机构入口</p>
                <p class="pointer_box btn" @click="login(2)">监管机构入口</p>
                <p class="pointer_box btn" @click="login(1)">指挥中心入口</p>
            </div>
            <p class="txt pointer_box">机构版APP下载</p>
            <p @click="contact()" class="txt pointer_box">合作查询</p>
            <p @click="feedback()" class="txt pointer_box">意见反馈</p>
            <p @click="aboutus()" class="txt pointer_box">关于大救星</p>
                <div class="rq_one">
                    <p>下载大救星</p>
                    <img src="../../../static/img/rq_code_dow.png" alt="">
                </div>
                <div class="rq_two">
                    <p>微信公众号</p>
                    <img src="../../../static/img/rq_code_public.png" alt="">
                </div>
            </div>
            <div class="footer_bottom">
                大救星版权所有@2018
            </div>
        </footer>
    </div>
</template>

<script>
import { Message } from "element-ui";
import constants from "@/util/constants.js";
export default {
  data() {
    return {
      flag: true,
      usertype: "",
      user: "",
      pwd: ""
    };
  },
  methods: {
    news() {
      this.$router.push({
        name: "news"
      });
    },
    league() {
      this.$router.push({
        name: "league"
      });
    },
    stars() {
      this.$router.push({
        name: "stars"
      });
    },
    feedback() {
      this.$router.push({
        name: "feedback"
      });
    },
    aboutus() {
      this.$router.push({
        name: "aboutus"
      });
    },
    dowapp() {
      this.$router.push({
        name: "dowapp"
      });
    },
    index() {
      this.$router.push({
        name: "Index"
      });
    },
    contact() {
      this.$router.push({
        name: "contact"
      });
    },
    listlogin() {
      let login_list = document.querySelector(".login");
      if (this.flag) {
        login_list.style.display = "block";
        this.flag = false;
      } else {
        login_list.style.display = "none";
        this.flag = true;
      }
    },
    login(v) {
      console.log(v);
      let login_box = document.querySelector(".login_box");
      login_box.style.display = "block";
      this.usertype = v;
    },
    tobtn(v) {
      let that = this;
      if (v === "cancel") {
        let login_box = document.querySelector(".login_box");
        login_box.style.display = "none";
      } else {
        // 先匹配密码正则
        // if (!this.pwd.match(/^[a-zA-Z]\w{5,17}$/)) {
        //   Message.error(
        //     "密码请以字母开头，长度在6~18之间，只能包含字母、数字和下划线"
        //   );
        // }
        // 请求 判断角色
        // 0 救援机构 fac
        // 1 指挥中心
        // 2 监管机构
        fetch(constants.domain+"rescue/user/login", {
          method: "POST",
          body: `username=${this.user}&pwd=${this.pwd}`,
          mode: "cors",
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        })
          .then(function(res) {
            return res.json();
          })
          .then(function(data) {
            if (data.code === 0) {
              console.log(that.usertype);
              if (Number(data.obj.user.type) == Number(that.usertype)) {
                if (that.usertype == 0) {
                  Message({
                    message: "救援机构登录成功",
                    type: "success"
                  });
                  window.localStorage.setItem(
                    "data",
                    JSON.stringify({
                      data: data.obj.token
                    })
                  );
                  window.localStorage.setItem(
                    "insti",
                    JSON.stringify(data.obj.user.insti)
                  );
                  that.$router.push({
                    name: "FacIndex",
                    params: {
                      token: data.obj.token,
                      insti: data.obj.user.insti
                    }
                  });
                } else if (that.usertype === 2) {
                  Message({
                    message: "监管机构登录成功",
                    type: "success"
                  });
                  window.localStorage.setItem(
                    "data",
                    JSON.stringify({
                      data: data.obj.token
                    })
                  );
                  window.localStorage.setItem(
                    "insti",
                    JSON.stringify(data.obj.user.insti)
                  );
                  that.$router.push({
                    name: "RegIndex",
                    params: {
                      token: data.obj.token,
                      insti: data.obj.user.insti
                    }
                  });
                } else if (that.usertype === 1) {
                  Message({
                    message: "指挥中心登录成功",
                    type: "success"
                  });
                  window.localStorage.setItem(
                    "data",
                    JSON.stringify({
                      data: data.obj.token
                    })
                  );
                  window.localStorage.setItem(
                    "insti",
                    JSON.stringify(data.obj.user)
                  );
                  console.log(data, data.obj);
                  that.$router.push({
                    name: "ComIndex",
                    params: {
                      token: data.obj.token,
                      insti: data.obj.user
                    }
                  });
                }
              } else {
                if (that.usertype == 0 && data.obj.user.type != 0) {
                  Message.error("登录失败，该用户不属于救援机构");
                } else if (that.usertype == 1 && data.obj.user.type != 1) {
                  Message.error("登录失败，该用户不属于指挥中心");
                } else if (that.usertype == 2 && data.obj.user.type != 2) {
                  Message.error("登录失败，该用户不属于监管机构");
                }
              }
            } else if (data.code === 200026) {
              //   alert("登录失败,用户名或密码错误");
              Message.error("登录失败，用户名或密码错误");
            } else {
              Message.error("登录失败，未知错误");
              //   alert("登录失败,其他错误");
            }
            console.log(data);
          });
      }
    }
  }
};
</script>

<style scoped>
@import url(../../../static/css/global.css);
@import url(../../css/news.css);
</style>


// WEBPACK FOOTER //
// src/components/news/newsDetail5.vue